import React, {Component} from 'react';
import PageHeader from '../components/Headers/PageHeader';
import Divider from '../gadgets/Divider';
import Image from "../components/Image";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Helmet} from 'react-helmet';

import sponsors from '../_Utilities/data/sponsors';

class SponsorsPage extends Component {
    render() {
        const headerContent = {
            tag: 'Check out our',
            title: 'Sponsors',
            description: 'Thank you to all our amazing sponsors for making the 2018 Design grad show possible!'
        };

        return (
            <div className={'container section--white'}>
                <Helmet>
                    <title>Sponsors • D18</title>
                </Helmet>
                <PageHeader color={'purple'} content={headerContent}/>
                <section>
                    <div className={'grid'}>
                        <div className={'col--12'}>
                            <div className={'content'}>
                                <h2>Platinum Sponsors</h2>
                                <Divider color={'purple'} type={'short'}/>
                            </div>
                        </div>
                        {sponsors.platinum.map((sponsor, i) => {
                            if (i % 2 === 0) {
                                return (
                                    <div className={"col--12 col--no-padding content__section content__flex"} key={i}>
                                        <div className={"col--5 col--center"}>
                                            <a href={sponsor.link} target={'_blank'}>
                                                <Image src={sponsor.logo} aspectRatio={'4:3'} contain/>
                                            </a>
                                        </div>
                                        <div className={"col--7 col--center"}>
                                            <div>
                                                {sponsor.description}
                                                <br/>
                                                <br/>
                                                <div className={'content__link'} key={i}>
                                                    <a href={`${sponsor.link}`} className={'link'}
                                                       target={'_blank'}>
                                                        <FontAwesomeIcon className={'icon icon--small'}
                                                                         icon={"desktop"}/>
                                                        {sponsor.displayLink}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div className={"col--12 col--no-padding content__section content__flex"} key={i}>
                                        <div className={"col--8 col--center info"}>
                                            <div>
                                                {sponsor.description}
                                                <br/>
                                                <br/>
                                                <div className={'content__link'} key={i}>
                                                    <a href={`${sponsor.link}`} className={'link'}
                                                       target={'_blank'}>
                                                        <FontAwesomeIcon className={'icon icon--small'}
                                                                         icon={"desktop"}/>
                                                        {sponsor.displayLink}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"col--4 col--center image-on-top"}>
                                            <a href={sponsor.link} target={'_blank'}>
                                                <Image src={sponsor.logo} aspectRatio={'4:3'} contain/>
                                            </a>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </section>
                <section className={'section--grey'}>
                    <div className={'grid'}>
                        <div className={'col--12'}>
                            <div className={'content'}>
                                <h2>Gold Sponsors</h2>
                                <Divider color={'purple'} type={'short'}/>
                            </div>
                        </div>
                        {sponsors.gold.map((sponsor, i) => {
                            if (i % 2 === 0) {
                                return (
                                    <div className={"col--12 col--no-padding content__section content__flex"} key={i}>
                                        <div className={"col--5 col--center"}>
                                            <a href={sponsor.link} target={'_blank'}>
                                                <Image src={sponsor.logo} aspectRatio={'4:3'} contain/>
                                            </a>
                                        </div>
                                        <div className={"col--7 col--center"}>
                                            <div>
                                                {sponsor.description}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div className={"col--12 col--no-padding content__section content__flex"} key={i}>
                                        <div className={"col--7 col--center info"}>
                                            <div>
                                                {sponsor.description}
                                            </div>
                                        </div>
                                        <div className={"col--5 col--center image-on-top"}>
                                            <a href={sponsor.link} target={'_blank'}>
                                                <Image src={sponsor.logo} aspectRatio={'4:3'} contain/>
                                            </a>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </section>
                <section>
                    <div className={'grid'}>
                        <div className={'col--12'}>
                            <div className={'content'}>
                                <h2>Silver Sponsors</h2>
                                <Divider color={'purple'} type={'short'}/>
                            </div>
                        </div>
                        {sponsors.silver.map((sponsor, i) => {
                            return (
                                <div className={"col--4 mob-col--6"} key={i}>
                                    <a href={sponsor.link} target={'_blank'}>
                                        <Image src={sponsor.logo} aspectRatio={'4:3'} contain/>
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                </section>
                <section>
                    <div className={'grid'}>
                        <div className={'col--12'}>
                            <div className={'content'}>
                                <h2>Bronze Sponsors</h2>
                                <Divider color={'purple'} type={'short'}/>
                            </div>
                        </div>
                        {sponsors.bronze.map((sponsor, i) => {
                            return (
                                <div className={"col--3 mob-col--4"} key={i}>
                                    <a href={sponsor.link} target={'_blank'}>
                                        <Image src={sponsor.logo} aspectRatio={'4:3'} contain/>
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                </section>
            </div>
        )
    }
}

export default SponsorsPage;